import { reportWebVitals } from 'src/helpers/reportWebVitals';
import { reportGoogleTranslate } from 'src/utils/reportGoogleTranslate/reportGoogleTranslate';
import { renderReactWithStyledComponents } from '../helpers/renderComponent';
import Hotel from '../routes/Hotel';

import '../styles/pages/hotel_page.scss';

export default renderReactWithStyledComponents('Hotels', Hotel);

reportWebVitals();

reportGoogleTranslate();
